import { Mail, Phone, Heart } from "lucide-react";
import pkg from "../../../package.json";
const appVersion = pkg.version;

export function FooterPanel() {
  return (
    <footer className="px-4 py-4 border-t border-white/10 text-slate-200/80 text-[13px]">
      {/* === BLOCCO 1: Copyright + Versione === */}
      <div className="space-y-1.5">
        <div className="flex items-center justify-between">
          <p className="font-medium text-slate-100">
            © {new Date().getFullYear()} Italpreziosi
          </p>
          <span className="inline-flex items-center rounded-md border border-white/10 bg-white/5 px-2 py-0.5 leading-none tabular-nums text-[11px]">
            v{appVersion}
          </span>
        </div>
        <p className="text-slate-400 text-[12px] leading-snug">
          Tutti i diritti riservati.
        </p>
      </div>

      {/* Divider */}
      {/* <div className="my-3 h-px bg-gradient-to-r from-white/10 via-white/5 to-transparent" /> */}

      {/* === BLOCCO 2: Supporto (Metriks) === */}
      <div className="space-y-2 hidden">
        <h4 className="text-[11px] uppercase tracking-wide text-slate-400">
          Supporto tecnico
        </h4>
        <ul className="space-y-1.5">
          <li>
            <a
              href="mailto:info@metriks.ai"
              className="group inline-flex items-center gap-2 rounded-md px-2 py-1 hover:bg-white/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/30 transition"
            >
              <Mail className="h-3.5 w-3.5 opacity-80 group-hover:opacity-100" />
              <span className="truncate">info@metriks.ai</span>
            </a>
          </li>
          <li>
            <a
              href="tel:+393333204166"
              className="group inline-flex items-center gap-2 rounded-md px-2 py-1 hover:bg-white/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/30 transition"
            >
              <Phone className="h-3.5 w-3.5 opacity-80 group-hover:opacity-100" />
              <span>+39 333 320 4166</span>
            </a>
          </li>
        </ul>
      </div>

      <div className="my-3 h-px bg-gradient-to-r from-white/5 via-white/10 to-white/5" />

      {/* === Credits === */}
      <p className="text-[12px] leading-relaxed text-slate-400 flex justify-center items-center">
        <div>
          Made with <Heart className="inline h-3.5 w-3.5 text-purple-400" /> by{" "}
          <a
            href="https://www.metriks.ai"
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-purple-400 hover:text-purple-500 transition-colors"
          >
            Metriks.AI
          </a>
        </div>
      </p>
    </footer>
  );
}
